import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiUrl, apiFetch } from '../../config/api';
import './ProductionOverview.css';

function ProductionOverview() {
  const { t } = useTranslation('production');
  const [loading, setLoading] = useState(true);
  const [metrics, setMetrics] = useState({
    orders: { active: 0, completed_today: 0, urgent: 0 },
    machines: { total: 0, active: 0, in_use_now: 0, utilization_percent: 0 },
    inventory: { low_stock_count: 0 }
  });

  // Fetch production metrics
  useEffect(() => {
    fetchProductionMetrics();

    // Auto-refresh every 60 seconds
    const interval = setInterval(fetchProductionMetrics, 60000);
    return () => clearInterval(interval);
  }, []);

  const fetchProductionMetrics = async () => {
    try {
      const response = await apiFetch(getApiUrl('/api/production/metrics/overview'));
      if (response.ok) {
        const data = await response.json();
        setMetrics(data);
      }
    } catch (error) {
      console.error('Error fetching production metrics:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="production-overview">
      {/* Key Metrics Cards - 2 rows of 3 */}
      <div className="kpi-grid">
        <div className="kpi-card">
          <div className="kpi-header">
            <span className="kpi-icon">🏭</span>
            <span className="kpi-label">{t('overview.kpi.activeOrders')}</span>
          </div>
          <div className="kpi-value">{loading ? '...' : metrics.orders.active}</div>
          <div className="kpi-footer">
            <div className="kpi-change">
              {!loading && metrics.orders.urgent > 0 ? `${metrics.orders.urgent} ${t('overview.labels.urgent')}` : '-'}
            </div>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-header">
            <span className="kpi-icon">✅</span>
            <span className="kpi-label">{t('overview.kpi.completedToday')}</span>
          </div>
          <div className="kpi-value">{loading ? '...' : metrics.orders.completed_today}</div>
        </div>

        <div className="kpi-card">
          <div className="kpi-header">
            <span className="kpi-icon">⚙️</span>
            <span className="kpi-label">{t('overview.kpi.machinesInUse')}</span>
          </div>
          <div className="kpi-value">
            {loading ? '...' : `${metrics.machines.in_use_now}/${metrics.machines.active}`}
          </div>
          <div className="kpi-footer">
            <div className="kpi-change">{metrics.machines.utilization_percent}% {t('overview.labels.utilization')}</div>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-header">
            <span className="kpi-icon">📦</span>
            <span className="kpi-label">{t('overview.kpi.materialStatus')}</span>
          </div>
          <div className="kpi-value">{loading ? '...' : metrics.inventory.low_stock_count}</div>
          <div className="kpi-footer">
            <div className="kpi-change">{t('overview.labels.lowStockItems')}</div>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-header">
            <span className="kpi-icon">⏸️</span>
            <span className="kpi-label">{t('overview.kpi.onHoldOrders')}</span>
          </div>
          <div className="kpi-value">{loading ? '...' : metrics.orders.on_hold}</div>
        </div>

        <div className="kpi-card">
          <div className="kpi-header">
            <span className="kpi-icon">📅</span>
            <span className="kpi-label">{t('overview.kpi.plannedThisWeek')}</span>
          </div>
          <div className="kpi-value">{loading ? '...' : metrics.orders.planned_this_week}</div>
        </div>
      </div>
    </div>
  );
}

export default ProductionOverview;